import React from "react";
import { motion } from "framer-motion";
import W2 from "../Images/W2.png";
import Aim from "../Images/Aim.png";
import Folder from "../Images/Folder.png";
import File from "../Images/Stack.png";
import Gear from "../Images/Gear.png";

const Whyus = () => {
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
    hover: { scale: 1.05, transition: { duration: 0.3 } },
  };

  const cards = [
    {
      img: Aim,
      name: 'Innovation for Growth and Success',
      text: 'We stay at the forefront of technology to deliver cutting-edge solutions that drive innovation and efficiency. Our expertise ensures scalable, future-ready applications tailored to your needs.',
    },
    {
      img: Folder,
      name: 'Security ensures safety, trust, and protection.',
      text: 'We implement robust security measures to protect your data and systems, ensuring confidentiality, integrity, and reliability. Our advanced cybersecurity solutions safeguard against threats, prevent breaches, and enhance resilience.',
    },
    {
      img: File,
      name: 'Scalability ensures growth without performance loss.',
      text: 'Our scalable solutions adapt seamlessly to your evolving business needs, maintaining top performance while supporting growth and expansion.',
    },
    {
      img: Gear,
      name: 'Future-Ready Technology',
      text: 'We provide scalable, flexible, and future-ready technology to support your expansion. Our adaptive frameworks ensure sustained efficiency and performance as your business grows.',
    },
  ];

  return (
    <>
    <br /><br /><br /><br />
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }}
        className="flex flex-col lg:flex-row items-start w-full"
      >
        {/* Left Section */}
        <div className="w-full lg:w-1/2 px-6 pt-6 pb-4 md:px-8 lg:px-6 lg:pb-0">
          <motion.div
            initial={{ opacity: 0, y: -30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="relative flex flex-col items-start"
          >
            <motion.button
              whileHover={{ scale: 1.1 }}
              className="bg-[#432DD7] text-white font-[Nunito] text-[18px] md:text-[20px] w-[180px] md:w-[243px] h-[50px] md:h-[67px] rounded-full font-medium"
            >
              Why Choose Us
            </motion.button>

            <motion.img
              src={W2}
              alt="Illustration"
              className="absolute w-14 h-14 -top-10 left-[150px] md:left-[200px]"
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              transition={{ duration: 0.5, delay: 0.5 }}
            />

            <h2 className="text-[24px] md:text-[36px] font-bold mt-5" style={{ fontFamily: "PT Sans" }}>
              Security ensures
            </h2>
            <h2 className="font-[Allison] text-[#432DD7] text-[24px] md:text-[36px] font-normal">
              safety, trust, and protection.
            </h2>
            <p className="text-[13px] md:text-[16px] text-[#62739E] font-[Nunito] mt-2 md:max-w-[90%]">
              We are committed to delivering exceptional value and results for our clients.
            </p>
          </motion.div>
        </div>

        {/* Right Section */}
        <div className="w-full lg:w-1/2 px-6 pt-0 pb-6 md:px-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {cards.map((item, index) => (
            <motion.div
              key={index}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              whileHover="hover"
              viewport={{ once: false, amount: 0.2 }}
              className="bg-white p-5 rounded-xl"
            >
              <img src={item.img} alt="" className="mb-4 w-12 h-12" />
              <h2 className="text-[#432DD7] text-[18px] md:text-[20px] font-[700] font-[Nunito] mb-2">
                {item.name}
              </h2>
              <p className="text-[14px] md:text-[15px] text-[#333] font-[Nunito] text-justify leading-relaxed">
                {item.text}
              </p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </>
  );
};

export default Whyus;
